export const userTypeArray = 
[
	{
		id: 0,
		name: 'Developer'
	},
	{
		id: 1,
		name: 'Employee'
	},
	{
		id: 2,
		name: 'Administrative'
	},
	{
		id: 3,
		name: 'Admin'
	}
];

export const userType = { 
	Developer: 0, 
	Employee: 1, 
	Administrative: 2, 
	Admin: 3
}

export const statusLeaves = {
	pending: 0,
	approved: 1,
	rejected: 2
}

export const typeFeatures = [
	{
		name: 'Contract',
		id: 0
	},
	{
		name: 'Technical Support',
		id: 1
	},
	{
		name: 'All',
		id: 2
	}
]
